module.exports = Smoothscroll = function(el){
  this.element = $(el);
  this.speed = 300;
  this.event();
};
Smoothscroll.prototype.event = function(){
  var self = this;
  this.element.on('click',function(e){
    var href = $(this).attr('href');

    // anchor link
    if(href !== '#' && href.match(/^\#/)){
      var target = $(href);
      self.moveTo(e, target);
      return false;
    }

    // include nav
    if(href.match(/^\u002f#/)){
      var target = href.split('/#')[1];
          target = $('#' + target);
      self.moveTo(e, target);
    }

  });
};
Smoothscroll.prototype.moveTo = function(e, target){
  if(target.length !== 0){
    var offset = target.offset().top;
    $('html,body').animate({scrollTop:offset}, this.speed, 'swing');
  }
};


//////////////////
// WEBPACK FOOTER
// ./js/_modules/smoothScroll.js
// module id = 2
// module chunks = 0